<template>
  <img :src="logoSrc" :alt="alt" :style="{ height: `${height}px` }" class="w-auto" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const props = withDefaults(
  defineProps<{
    height?: number
    alt?: string
  }>(),
  {
    height: 44,
    alt: 'Nebula Soft',
  },
)

const { currentPresetName } = useColors()

const logoSrc = computed(() => {
  return currentPresetName.value === 'dark' ? '/logoLetraBlanco.png' : '/logoLetraNegro.svg'
})
</script>
